import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public getParsedItem(key: string) {
    return JSON.parse(localStorage.getItem(key) ?? 'null');
  }

  public getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  public setItem(key: string, value: any) {
    return localStorage.setItem(key, JSON.stringify(value));
  }

  public removeItem(key: string) {
    return localStorage.removeItem(key);
  }

  public clear() {
    localStorage.clear();
  }
}
